import HCaptcha from '@hcaptcha/react-hcaptcha'

interface HCaptchaFieldProps {
  onToken: (token: string) => void
}

const siteKey = (import.meta as any).env.VITE_HCAPTCHA_SITE_KEY as string | undefined

export default function HCaptchaField({ onToken }: HCaptchaFieldProps) {
  if (!siteKey) return null

  return (
    <div className="flex justify-center py-2">
      <HCaptcha
        sitekey={siteKey}
        theme="dark"
        onVerify={onToken}
        onExpire={() => onToken('')}
        onError={() => onToken('')}
      />
    </div>
  )
}

export { siteKey as hCaptchaSiteKey }
